"use strict";
import angular from "angular";

import "./widget.mapbox.directives";

angular.module("widget.mapbox", [
    "widget.mapbox.directives",
]);